import React, { useState, useEffect } from 'react';
import apiClient from '../../networking/axiosconfig';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Switch, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Box, Checkbox, TextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import AlertIcon from '@mui/icons-material/Warning';
import SalesDialog from './add.js'; // Import the reusable dialog
import {formatDate} from '../../Utils';
const SalesList = () => {
  const { data: config } = useSelector((state) => state.config);
  const [sales, setSales] = useState([]);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSaleToEdit, setSelectedSaleToEdit] = useState(null);
  const [isStatusDialogOpen, setIsStatusDialogOpen] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [statusSale, setStatusSale] = useState(null);
  const [saleName, setSaleName] = useState('');
  const [newStatus, setNewStatus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSales();
  }, []); // Empty dependency array means this effect runs only once on mount

  const fetchSales = async () => {
    try {
      const response = await apiClient.get(`${config.API_BASE_URL}/api/sales`);
      setSales(response.data);
    } catch (error) {
      console.error('Error fetching sales:', error);
    }
  };

  const filteredSales = sales.filter((sale) => {
    const searchTermLower = searchTerm.toLowerCase();
    const nameMatch = sale.name.toLowerCase().includes(searchTermLower);
    const idMatch = sale._id.toLowerCase().includes(searchTermLower);
    return nameMatch || idMatch;
  });

  const handleAddDialogOpen = () => {
    setIsAddDialogOpen(true);
  };

  const handleAddDialogClose = () => {
    setIsAddDialogOpen(false);
  };

  const handleSaleAdded = (newSale) => {
    setSales((prevSales) => [...prevSales, newSale]);
  };

  const handleEditDialogOpen = (sale) => {
    setSelectedSaleToEdit(sale);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setIsEditDialogOpen(false);
    setSelectedSaleToEdit(null);
  };

  const handleStatusChange = async (productId, isActive) => {
    const sale = sales.find(p => p._id === productId);
    setStatusSale(productId);
    setSaleName(sale?.name || '');
    setNewStatus(isActive);
    setIsStatusDialogOpen(true);
  };

  const confirmStatusChange = async () => {
    setStatusLoading(true);
    try {
      await apiClient.put(`${config.API_BASE_URL}/api/sales/${statusSale}/status`, { isActive: newStatus });
      const updatedSales = sales.map((sale) => 
        sale._id === statusSale ? { ...sale, isActive: newStatus } : sale
      );
      setSales(updatedSales);
      setIsStatusDialogOpen(false);
    } catch (error) {
      console.error('Error updating product status:', error);
    } finally {
      setStatusLoading(false);
    }
  };

  const handleSaleUpdated = (updatedSale) => {
    const updatedSales = sales.map((sale) =>
      sale._id === updatedSale._id ? updatedSale : sale
    );
    setSales(updatedSales);
  };

  const openDetailsPage = (sale) => {
    navigate(`/sales/${sale._id}`);
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Sales List</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <TextField
            size="small"
            placeholder="Search by name or ID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 200 }}
          />
          <Button variant="contained" color="success" onClick={handleAddDialogOpen}>
            Add New Sale
          </Button>
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
        <thead style={{ backgroundColor: '#1976d2', color: 'white' }}>
          <tr>
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'center', width: 'auto' }}>S.No</th>
            {/* <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'left', width: 'auto' }}>Product ID</th> */}
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'left', width: 'auto' }}>Name</th>
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'left', width: 'auto' }}>Start Date</th>
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'left', width: 'auto' }}>End Date</th>
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'right', width: 'auto' }}>Discount</th>
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'right', width: 'auto' }}>No of Products</th>
            {/* <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'center', width: 'auto' }}>Details</th> */}
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', borderRight: '1px solid #ddd', textAlign: 'center', width: 'auto' }}>Edit</th>
            <th style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'center', width: 'auto' }}>Active</th>
          </tr>
        </thead>
        <tbody>
          {filteredSales.map((sale, index) => (
            <tr key={sale._id} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd', textAlign: 'center' }}>
                {index + 1}
              </td>
              {/* <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd' }}>{sale._id}</td> */}
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd' }}>{sale.name}</td>
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd' }}>{formatDate(sale.startDate)}</td>
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd' }}>{formatDate(sale.endDate)}</td>
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd', textAlign: 'right' }}>{sale.discountPercentage}%</td>
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd', textAlign: 'right' }}>{sale.products.length}</td>
              {/* <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd', textAlign: 'center' }}>
                <Button onClick={() => openDetailsPage(sale)} startIcon={<InfoIcon />} size="small" variant="outlined" color="info">
                  Details
                </Button>
              </td> */}
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', borderRight: '1px solid #ddd', textAlign: 'center' }}>
                <Button onClick={() => handleEditDialogOpen(sale)} startIcon={<EditIcon />} size="small" variant="outlined" color="warning">
                  Edit
                </Button>
              </td>
              <td style={{ padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center' }}>
                <Checkbox
                  checked={sale.isActive}
                  onChange={(e) => handleStatusChange(sale._id, e.target.checked)}
                  size="small"
                  disabled={statusLoading && sale._id === statusSale}
                  sx={{
                    '&.Mui-checked': {
                      color: '#4caf50', // Green when checked
                    },
                    '&.Mui-checked:hover': {
                      color: '#4caf50', // Keep green on hover
                    },
                    '&.Mui-checked.Mui-disabled': {
                      color: '#4caf50', // Keep green when disabled
                    },
                    '&:not(.Mui-checked)': {
                      color: '#f44336', // Red when unchecked
                    },
                    '&:not(.Mui-checked):hover': {
                      color: '#f44336', // Keep red on hover
                    },
                    '&:not(.Mui-checked).Mui-disabled': {
                      color: '#f44336', // Keep red when disabled
                    },
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Status Confirmation Dialog */}
      <Dialog open={isStatusDialogOpen} onClose={() => setIsStatusDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {statusLoading ? 'Updating Status...' : 'Confirm Status Change'}
        </DialogTitle>
        <DialogContent>
          {statusLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
              <CircularProgress />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <AlertIcon color="warning" sx={{ fontSize: 40 }} />
              <div>
                <p>Are you sure you want to mark <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{saleName}</span> as <span style={{ color: newStatus ? '#4caf50' : '#f44336', fontWeight: 'bold' }}>{newStatus ? 'Active' : 'Inactive'}</span>?</p>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsStatusDialogOpen(false)} color="error">
            Cancel
          </Button>
          <Button onClick={confirmStatusChange} variant="contained" color="success">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Use the reusable ProductDialog for adding */}
      <SalesDialog
        open={isAddDialogOpen}
        onClose={handleAddDialogClose}
        onProductAdded={handleSaleAdded}
      />

      {/* Use the reusable ProductDialog for editing */}
      {selectedSaleToEdit && (
        <SalesDialog
          open={isEditDialogOpen}
          onClose={handleEditDialogClose}
          initialProduct={selectedSaleToEdit}
          onProductUpdated={handleSaleUpdated}
        />
      )}  
    </div>
  );
};

export default SalesList;